import styled from 'styled-components/macro'
import { useLocalization } from 'localization'

function vimeoPlayerUrl(vimeoUrl, autoplay) {
  // format: “https://player.vimeo.com/video/315695379?playsinline=0”
  const video = vimeoUrl.match(/^https:\/\/vimeo\.com\/(.*)$/)[1]
  let url = `https://player.vimeo.com/video/${video}?playsinline=0`
  if (autoplay) {
    url = `${url}&autoplay=1&allow=autoplay`
  }
  return url
}

const StyledIframe = styled.iframe`
  width: 46.4rem;
  max-width: calc(100vw - 3.2rem);
  height: calc(46.4rem * ${(props) => props.height / props.width});
`

const VideoPlayer = (props) => {
  const { t } = useLocalization()

  return (
    <iframe
      className={props.className}
      title={t('dweb_misc_vimeo_video_player')}
      src={vimeoPlayerUrl(props.url, props.autoplay)}
      frameBorder="0"
      width={props.width || 340}
      height={props.height || 200}
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
      allowFullScreen={true}
    ></iframe>
  )
}

const CustomVideoPlayer = (props) => {
  const { t } = useLocalization()

  return (
    <StyledIframe
      className={props.className}
      title={t('dweb_misc_vimeo_video_player')}
      src={vimeoPlayerUrl(props.url, props.autoplay)}
      frameBorder="0"
      width={props.width || 340}
      height={props.height || 200}
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
      allowFullScreen={true}
    ></StyledIframe>
  )
}

VideoPlayer.Custom = CustomVideoPlayer

export default VideoPlayer
